export default __webpack_public_path__ + "static/media/kingsley.4e06f21b.png";